import React from 'react';
import { CountryDropdown } from 'react-country-region-selector';
import "./Display.css"
 
 
const Countries = (props) => {
  
    return (
      <div>
        <CountryDropdown
          value={props.country}
          defaultOptionLabel="Select a country"
          onChange={(val) => val ? props.countryHandler(val) : props.countryHandler() } 
          className="countryDropDown"
          priorityOptions={["AU", "NZ" ]}
          />
      </div>
    );
}


export default Countries